export default class RegenerateTokenSuccessEvent extends CustomEvent {
  constructor(data) {
    super('regenerate_success', { detail: data });
  }
}
